import { render, staticRenderFns } from "./UnKnowTable.vue?vue&type=template&id=a24992e2&scoped=true&"
import script from "./UnKnowTable.vue?vue&type=script&lang=js&"
export * from "./UnKnowTable.vue?vue&type=script&lang=js&"
import style0 from "./UnKnowTable.vue?vue&type=style&index=0&id=a24992e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24992e2",
  null
  
)

export default component.exports